const Post = () => {
  return (
    <div className="w-[50%] border flex items-start relative p-3 rounded-md bg-white">
      <div className="border flex flex-col w-24 rounded-md">
        <img
          src="https://picsum.photos/200/300"
          className="w-24 h-14 object-cover"
          alt="Post Image"
        />
        <p className="text-xs leading-tight p-1">
          Lorem ipsum dolor sit amet consectetur, adipisicing elit.
        </p>
      </div>
      <p className="text-sm absolute right-10">
        at 12:30 PM <i className="fa-brands fa-square-instagram"></i>
      </p>
      <div className="">
        <Comment />
        <Comment />
        <Comment />

        <div className="flex items-center space-x-2 px-5">
          <i className="fa-solid fa-trash-can"></i>
          <i className="fa-regular fa-heart"></i>
          <div className="w-[400px] border rounded-lg flex items-center px-2 bg-lightblue">
            <input
              className="w-full rounded-lg placeholder:text-xs bg-lightblue focus:outline-none text-xs py-2"
              type="text"
              placeholder="Reply..."
            />
            <button>
              <i className="fa-solid fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const Comment = () => {
  return (
    <div className="pl-5 mt-1">
      <div className="mb-5">
        <div className="flex space-x-2 items-center">
          <img
            className="rounded-full w-8 h-8"
            src="https://i.pravatar.cc/30"
            alt="avatar"
          />
          <p className="flex space-x-2 text-sm">
            Lily Johns <span className="text-gray-500">@Lilyj</span> <br />
            <span className="font-semibold">Commented On Post</span>
          </p>
        </div>

        <p className="text-sm pt-2 max-w-sm">
          Wow new video is amazing can't wait to see more Lorem ipsum dolor, sit
          amet consectetur adipisicing elit.
        </p>
      </div>
    </div>
  );
};

export default Post;
